/// <reference types="./proposal_builder.d.mts" />
import * as $document_selector from "../../../common/data/ephemeral/document_selector.mjs";
import { File } from "../../../common/data/ephemeral/file.mjs";
import * as $pb from "../../../common/data/ephemeral/proposal_builder.mjs";
import { ProposalBuilder } from "../../../common/data/ephemeral/proposal_builder.mjs";
import * as $spreadsheet_selector from "../../../common/data/ephemeral/spreadsheet_selector.mjs";
import * as $project from "../../../common/data/project.mjs";
import * as $proposal from "../../../common/data/proposal.mjs";
import * as $proposal_element from "../../../common/data/proposal_element.mjs";
import * as $qualification_matrix from "../../../common/data/qualification_matrix.mjs";
import * as $tag from "../../../common/data/tag.mjs";
import * as $language from "../../../common/data/translate/language.mjs";
import * as $assoc from "../../../common_common/gleam/assoc.mjs";
import * as $file from "../../../ds/web/browser/file.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $level from "../../../grille_pain/grille_pain/toast/level.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $mime_types from "../../../mime_types/mime_types.mjs";
import * as $modem from "../../../modem/modem.mjs";
import * as $state from "../../data/model/state.mjs";
import { State } from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $proposals from "../../data/proposals.mjs";
import * as $route from "../../data/route.mjs";
import * as $effects from "../../frontend/effects.mjs";
import * as $modal from "../../frontend/effects/modal.mjs";
import * as $project_effects from "../../frontend/effects/project.mjs";
import * as $proposal_effects from "../../frontend/effects/proposal.mjs";
import * as $pb_effects from "../../frontend/effects/proposal_builder.mjs";
import * as $up_document_selector from "../../frontend/update/proposal_builder/document_selector.mjs";
import * as $up_pdf_selector from "../../frontend/update/proposal_builder/pdf_selector.mjs";
import * as $up_spreadsheet_selector from "../../frontend/update/proposal_builder/spreadsheet_selector.mjs";
import { Ok, toList, makeError, isEqual } from "../../gleam.mjs";

const FILEPATH = "src/frontend/update/proposal_builder.gleam";

function update_project(state, id) {
  let _block;
  let _pipe = $state.current_user_id(state);
  _block = $option.unwrap(_pipe, "");
  let user_id = _block;
  let _block$1;
  let _record = state;
  _block$1 = new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    new $state.NoModal(),
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
  let state$1 = _block$1;
  let $ = $assoc.get(state$1.projects, id);
  if ($ instanceof Ok) {
    let project = $[0];
    let _block$2;
    {
      let pb = state$1.proposal_builder;
      let proj = $pb.project(pb, project.org_id, user_id);
      _block$2 = $state.upsert_projects(
        state$1,
        toList([
          (() => {
            let _record$1 = project;
            return new $project.Project(
              _record$1.id,
              proj.name,
              proj.owners,
              _record$1.org_id,
              proj.deadline,
              proj.client,
              proj.collaborators,
              proj.metadata,
              _record$1.created_at,
              _record$1.status,
            );
          })(),
        ]),
      );
    }
    let state$2 = _block$2;
    return [
      state$2,
      $effect.batch(
        toList([
          $modem.back(1),
          $project_effects.update_project(state$2, id, false),
        ]),
      ),
    ];
  } else {
    return [state$1, $effect.none()];
  }
}

function update_proposal(state, id, retrigger_questions, override_validated) {
  let _block;
  let _record = state;
  _block = new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    new $state.NoModal(),
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
  let state$1 = _block;
  let $ = $assoc.get(state$1.proposals.all, id);
  if ($ instanceof Ok) {
    let proposal = $[0];
    let _block$1;
    {
      let pb = state$1.proposal_builder;
      _block$1 = $state.upsert_proposals(
        state$1,
        toList([
          (() => {
            let _pipe = proposal;
            let _pipe$1 = $proposal.update_name(_pipe, pb.proposal_name);
            let _pipe$2 = $proposal.update_tags(_pipe$1, pb.proposal_tags);
            let _pipe$3 = $proposal.update_languages(
              _pipe$2,
              pb.proposal_languages,
            );
            let _pipe$4 = $proposal.update_proposal_context(
              _pipe$3,
              $pb.additional_context(pb),
            );
            return $proposal.update_style_guidelines(
              _pipe$4,
              pb.proposal_style_guidelines,
            );
          })(),
        ]),
      );
    }
    let state$2 = _block$1;
    return [
      state$2,
      $effect.batch(
        toList([
          $modem.back(1),
          $proposal_effects.update_proposal(
            state$2,
            id,
            false,
            retrigger_questions,
            override_validated,
          ),
        ]),
      ),
    ];
  } else {
    return [state$1, $effect.none()];
  }
}

function will_update_proposal(state, id) {
  let pb = state.proposal_builder;
  let $ = $assoc.get(state.proposals.all, id);
  if ($ instanceof Ok) {
    let proposal = $[0];
    let sort = (_capture) => { return $list.sort(_capture, $tag.compare); };
    let should_retrigger = ((!isEqual(
      proposal.metadata.proposal_context,
      $pb.additional_context(pb)
    )) || (!isEqual(sort(proposal.metadata.tags), sort(pb.proposal_tags)))) || (!isEqual(
      proposal.metadata.style_guidelines,
      pb.proposal_style_guidelines
    ));
    if (should_retrigger) {
      let _pipe = new $state.RetriggerProposalQuestions(id, false);
      let _pipe$1 = ((modal) => {
        let _record = state;
        return new State(
          _record.window_dimensions,
          _record.access_token,
          _record.analytics,
          _record.client,
          _record.collapsed_navbar,
          _record.comments,
          _record.comments_draft_mentions,
          _record.comments_in_edition,
          _record.connectors,
          _record.content_library,
          _record.copilot,
          _record.custom_rewording_input,
          _record.draft_comments,
          _record.dropdown_unsubscriber,
          _record.feed_opened,
          _record.language,
          _record.loading,
          modal,
          _record.modal_unsubscriber,
          _record.notifications,
          _record.notifications_unread,
          _record.opened_projects,
          _record.organization,
          _record.permissions,
          _record.projects,
          _record.proposal_builder,
          _record.proposals,
          _record.qualification_matrix,
          _record.route,
          _record.running_requests,
          _record.translations,
          _record.user,
          _record.sources_tooltip,
          _record.sources_tooltip_unsubscriber,
          _record.maintenance,
        );
      })(_pipe);
      return $pair.new$(_pipe$1, $modal.subscribe_close());
    } else {
      return update_proposal(state, id, false, false);
    }
  } else {
    return [state, $effect.none()];
  }
}

function update_proposal_builder_field(proposal_builder, msg) {
  if (msg instanceof $msg.UserAddedProposalLanguage) {
    let l = msg.language;
    return $pb.add_proposal_language(proposal_builder, l);
  } else if (msg instanceof $msg.UserAddedProposalTag) {
    let t = msg.tag;
    return $pb.add_proposal_tag(proposal_builder, t);
  } else if (msg instanceof $msg.UserAddedProposalStyleGuideline) {
    let s = msg.style_guideline;
    return $pb.add_proposal_style_guidelines(proposal_builder, s);
  } else if (msg instanceof $msg.UserEditedProjectUser) {
    let $ = msg.action;
    if ($ instanceof $msg.UserAddedCollaborator) {
      let u = $.user_id;
      return $pb.add_project_collaborator(proposal_builder, u);
    } else if ($ instanceof $msg.UserRemovedCollaborator) {
      let u = $.user_id;
      return $pb.remove_project_collaborator(proposal_builder, u);
    } else if ($ instanceof $msg.UserAddedOwner) {
      let u = $.user_id;
      return $pb.add_project_owner(proposal_builder, u);
    } else {
      let u = $.user_id;
      return $pb.remove_project_owner(proposal_builder, u);
    }
  } else if (msg instanceof $msg.UserRemovedProposalLanguage) {
    let l = msg.language;
    return $pb.remove_proposal_language(proposal_builder, l);
  } else if (msg instanceof $msg.UserRemovedProposalStyleGuideline) {
    return $pb.remove_proposal_style_guidelines(proposal_builder);
  } else if (msg instanceof $msg.UserRemovedProposalTag) {
    let t = msg.tag;
    return $pb.remove_proposal_tag(proposal_builder, t);
  } else if (msg instanceof $msg.UserSelectedProposalQualificationMatrix) {
    let id = msg.id;
    let qm = msg.answer;
    return $pb.update_qualification_matrix_item(proposal_builder, id, qm);
  } else if (msg instanceof $msg.UserSkippedProposalQualificationMatrix) {
    return $pb.next_step(proposal_builder);
  } else if (msg instanceof $msg.UserSubmittedProjectDetails) {
    return $pb.next_step(proposal_builder);
  } else if (msg instanceof $msg.UserSubmittedProposalDetails) {
    return $pb.next_step(proposal_builder);
  } else if (msg instanceof $msg.UserUpdatedContext) {
    let value = msg.value;
    return $pb.add_proposal_additional_context(proposal_builder, value);
  } else if (msg instanceof $msg.UserUpdatedProjectClient) {
    let project_client = msg.name;
    return $pb.update_project_client(proposal_builder, project_client);
  } else if (msg instanceof $msg.UserUpdatedProjectSalesforceId) {
    let salesforce_id = msg.name;
    return $pb.update_project_salesforce_id(proposal_builder, salesforce_id);
  } else if (msg instanceof $msg.UserUpdatedProjectDeadline) {
    let date = msg.deadline;
    return $pb.update_project_deadline(proposal_builder, date);
  } else if (msg instanceof $msg.UserUpdatedProjectName) {
    let name = msg.name;
    return $pb.update_project_name(proposal_builder, name);
  } else if (msg instanceof $msg.UserSelectedProjectId) {
    let value = msg[0];
    return $pb.update_project_id(proposal_builder, value);
  } else if (msg instanceof $msg.UserUpdatedProposalName) {
    let name = msg[0];
    return $pb.set_proposal_name(proposal_builder, name);
  } else {
    throw makeError(
      "panic",
      FILEPATH,
      "frontend/update/proposal_builder",
      440,
      "update_proposal_builder_field",
      "Should be handled in outer update",
      {}
    )
  }
}

function default_update(state, msg) {
  let _pipe = state.proposal_builder;
  let _pipe$1 = update_proposal_builder_field(_pipe, msg);
  let _pipe$2 = ((_capture) => {
    return $state.set_proposal_builder(state, _capture);
  })(_pipe$1);
  return $pair.new$(_pipe$2, $effect.none());
}

export function update(state, msg) {
  if (msg instanceof $msg.ApiReturnedSavedProposal) {
    let $ = msg.saved_proposal;
    if ($ instanceof Ok) {
      let proposal = $[0][0];
      let questions = $[0][1];
      let proposals = $proposals.upsert_all(state.proposals, toList([proposal]));
      let _block;
      let _record = proposals;
      _block = new $proposals.Proposals(
        _record.all,
        _record.filters,
        _record.filters_opened,
        _record.selected_questions,
        _record.add_opened,
        _record.more_question_opened,
        _record.more_proposal_opened,
        _record.more_unsubscriber,
        _record.block_page_size,
        _record.collaborators_opened,
        _record.change_owner_popup_opened,
        _record.change_status_popup_opened,
        _record.comment_displayed_opened,
        _record.emoji_comment_picker_id,
        _record.title_opened,
        _record.focus_comment,
        _record.popup_more_comment_id,
        (() => {
          let _record$1 = proposals.elements;
          return new $proposals.Elements(
            $dict.insert(
              proposals.elements.by_proposal,
              proposal.id,
              $list.map(
                questions,
                (q) => { return [$proposal_element.id(q), q]; },
              ),
            ),
            _record$1.data_sources,
            _record$1.data_points,
          );
        })(),
        _record.improvements_conversations,
        _record.conversations_input,
      );
      let _pipe = _block;
      let _pipe$1 = ((_capture) => {
        return $state.set_proposals(state, _capture);
      })(_pipe);
      return $pair.new$(
        _pipe$1,
        (() => {
          let _pipe$2 = new $route.ShowProposal(
            proposal.id,
            new None(),
            0,
            new None(),
            new None(),
            new None(),
          );
          let _pipe$3 = ((_capture) => {
            return new $route.Proposals(proposal.project_id, _capture);
          })(_pipe$2);
          let _pipe$4 = new $route.Projects(_pipe$3);
          return $route.replace(_pipe$4);
        })(),
      );
    } else {
      let _pipe = "Unable to save the proposal. Please, retry later";
      let _pipe$1 = $effects.toast(_pipe, new $level.Error());
      return ((_capture) => { return $pair.new$(state, _capture); })(_pipe$1);
    }
  } else if (msg instanceof $msg.ProposalBuilderHandledSpreadsheetSelector) {
    let $ = msg.msg;
    if ($ instanceof $msg.UserCancelledSpreadsheetSelection) {
      let _pipe = state.proposal_builder;
      let _pipe$1 = $pb.back_to_upload(_pipe);
      let _pipe$2 = ((_capture) => {
        return $state.set_proposal_builder(state, _capture);
      })(_pipe$1);
      return $pair.new$(_pipe$2, $effect.none());
    } else if ($ instanceof $msg.UserSubmittedXlsx) {
      let _block;
      let $1 = state.route;
      if ($1 instanceof $route.Overview) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          83,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.ContentLibrary) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          78,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Projects) {
        let $2 = $1[0];
        if ($2 instanceof $route.AddProject) {
          _block = new $route.AddProject(true);
        } else if ($2 instanceof $route.AddProposal) {
          _block = new $route.AddProposal(true);
        } else {
          throw makeError(
            "panic",
            FILEPATH,
            "frontend/update/proposal_builder",
            90,
            "update",
            "`panic` expression evaluated.",
            {}
          )
        }
      } else if ($1 instanceof $route.CoPilot) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          77,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Settings) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          84,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Organization) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          82,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Analytics) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          76,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Support) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          86,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Login) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          80,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.SlackLogin) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          85,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Editor) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          79,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          81,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      }
      let _pipe = _block;
      let _pipe$1 = new $route.Projects(_pipe);
      let _pipe$2 = ((_capture) => {
        return $state.update_route(state, _capture);
      })(_pipe$1);
      return $pair.new$(_pipe$2, $pb_effects.send_proposal_builder(state));
    } else {
      let msg$1 = $;
      let $1 = state.proposal_builder;
      let proposal_spreadsheet = $1.proposal_spreadsheet;
      let was_processing = proposal_spreadsheet.processing;
      let $2 = $up_spreadsheet_selector.update(
        state,
        proposal_spreadsheet,
        msg$1,
      );
      let proposal_spreadsheet$1 = $2[0];
      let effects = $2[1];
      let _block;
      let _record = state.proposal_builder;
      _block = new $pb.ProposalBuilder(
        _record.edit_status,
        _record.step,
        _record.project_attachments,
        _record.project_client,
        _record.project_collaborators,
        _record.project_deadline,
        _record.project_name,
        _record.project_owners,
        _record.project_id,
        _record.proposal_pre_filled,
        _record.proposal_name,
        _record.proposal_tags,
        _record.proposal_additional_context,
        _record.proposal_style_guidelines,
        _record.proposal_default_language,
        _record.proposal_languages,
        _record.proposal_qualification_matrix,
        proposal_spreadsheet$1,
        _record.proposal_document,
        _record.proposal_pdf,
        _record.proposal_one_trust,
        _record.proposal_link_id,
        _record.salesforce_id,
      );
      let _pipe = _block;
      let _block$1;
      let $3 = was_processing && !proposal_spreadsheet$1.processing;
      if ($3) {
        _block$1 = $pb.next_step;
      } else {
        _block$1 = $function.identity;
      }
      let _pipe$1 = _block$1(_pipe);
      let _block$2;
      let $4 = $spreadsheet_selector.get_language(proposal_spreadsheet$1);
      if ($4 instanceof Some) {
        let language = $4[0];
        _block$2 = (_capture) => {
          return $pb.insert_default_language(_capture, language);
        };
      } else {
        _block$2 = $function.identity;
      }
      let _pipe$2 = _block$2(_pipe$1);
      let _pipe$3 = ((_capture) => {
        return $state.set_proposal_builder(state, _capture);
      })(_pipe$2);
      return $pair.new$(
        _pipe$3,
        (() => {
          let _pipe$4 = effects;
          let _pipe$5 = $effect.map(
            _pipe$4,
            (var0) => {
              return new $msg.ProposalBuilderHandledSpreadsheetSelector(var0);
            },
          );
          return $effect.map(
            _pipe$5,
            (var0) => { return new $msg.ProposalBuilder(var0); },
          );
        })(),
      );
    }
  } else if (msg instanceof $msg.ProposalBuilderHandledDocumentSelector) {
    let $ = msg.msg;
    if ($ instanceof $msg.UserSubmittedDocument) {
      let _block;
      let $1 = state.route;
      if ($1 instanceof $route.Overview) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          83,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.ContentLibrary) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          78,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Projects) {
        let $2 = $1[0];
        if ($2 instanceof $route.AddProject) {
          _block = new $route.AddProject(true);
        } else if ($2 instanceof $route.AddProposal) {
          _block = new $route.AddProposal(true);
        } else {
          throw makeError(
            "panic",
            FILEPATH,
            "frontend/update/proposal_builder",
            90,
            "update",
            "`panic` expression evaluated.",
            {}
          )
        }
      } else if ($1 instanceof $route.CoPilot) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          77,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Settings) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          84,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Organization) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          82,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Analytics) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          76,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Support) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          86,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Login) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          80,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.SlackLogin) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          85,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Editor) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          79,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          81,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      }
      let _pipe = _block;
      let _pipe$1 = new $route.Projects(_pipe);
      let _pipe$2 = ((_capture) => {
        return $state.update_route(state, _capture);
      })(_pipe$1);
      return $pair.new$(_pipe$2, $pb_effects.send_proposal_builder(state));
    } else {
      let msg$1 = $;
      let $1 = state.proposal_builder;
      let proposal_document = $1.proposal_document;
      let _pipe = $up_document_selector.update(state, proposal_document, msg$1);
      let _pipe$1 = $pair.map_first(
        _pipe,
        (proposal_document) => {
          let _block;
          let _record = state.proposal_builder;
          _block = new $pb.ProposalBuilder(
            _record.edit_status,
            _record.step,
            _record.project_attachments,
            _record.project_client,
            _record.project_collaborators,
            _record.project_deadline,
            _record.project_name,
            _record.project_owners,
            _record.project_id,
            _record.proposal_pre_filled,
            _record.proposal_name,
            _record.proposal_tags,
            _record.proposal_additional_context,
            _record.proposal_style_guidelines,
            _record.proposal_default_language,
            _record.proposal_languages,
            _record.proposal_qualification_matrix,
            _record.proposal_spreadsheet,
            proposal_document,
            _record.proposal_pdf,
            _record.proposal_one_trust,
            _record.proposal_link_id,
            _record.salesforce_id,
          );
          let _pipe$1 = _block;
          let _block$1;
          let $2 = $up_document_selector.is_docx_fetched(msg$1);
          if ($2) {
            _block$1 = $pb.next_step;
          } else {
            _block$1 = $function.identity;
          }
          let _pipe$2 = _block$1(_pipe$1);
          let _block$2;
          let $3 = $document_selector.get_language(proposal_document);
          if ($3 instanceof Some) {
            let language = $3[0];
            _block$2 = (_capture) => {
              return $pb.insert_default_language(_capture, language);
            };
          } else {
            _block$2 = $function.identity;
          }
          let _pipe$3 = _block$2(_pipe$2);
          return ((_capture) => {
            return $state.set_proposal_builder(state, _capture);
          })(_pipe$3);
        },
      );
      let _pipe$2 = $pair.map_second(
        _pipe$1,
        ((_capture) => {
          return $effect.map(
            _capture,
            (var0) => {
              return new $msg.ProposalBuilderHandledDocumentSelector(var0);
            },
          );
        }),
      );
      return $pair.map_second(
        _pipe$2,
        (_capture) => {
          return $effect.map(
            _capture,
            (var0) => { return new $msg.ProposalBuilder(var0); },
          );
        },
      );
    }
  } else if (msg instanceof $msg.ProposalBuilderHandledPdfSelector) {
    let $ = msg.msg;
    if ($ instanceof $msg.UserSubmittedPdf) {
      let _block;
      let $1 = state.route;
      if ($1 instanceof $route.Overview) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          83,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.ContentLibrary) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          78,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Projects) {
        let $2 = $1[0];
        if ($2 instanceof $route.AddProject) {
          _block = new $route.AddProject(true);
        } else if ($2 instanceof $route.AddProposal) {
          _block = new $route.AddProposal(true);
        } else {
          throw makeError(
            "panic",
            FILEPATH,
            "frontend/update/proposal_builder",
            90,
            "update",
            "`panic` expression evaluated.",
            {}
          )
        }
      } else if ($1 instanceof $route.CoPilot) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          77,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Settings) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          84,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Organization) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          82,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Analytics) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          76,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Support) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          86,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Login) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          80,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.SlackLogin) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          85,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else if ($1 instanceof $route.Editor) {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          79,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      } else {
        throw makeError(
          "panic",
          FILEPATH,
          "frontend/update/proposal_builder",
          81,
          "update",
          "`panic` expression evaluated.",
          {}
        )
      }
      let _pipe = _block;
      let _pipe$1 = new $route.Projects(_pipe);
      let _pipe$2 = ((_capture) => {
        return $state.update_route(state, _capture);
      })(_pipe$1);
      return $pair.new$(_pipe$2, $pb_effects.send_proposal_builder(state));
    } else {
      let msg$1 = $;
      let $1 = state.proposal_builder;
      let proposal_pdf = $1.proposal_pdf;
      let $2 = $up_pdf_selector.update(state, proposal_pdf, msg$1);
      let proposal_pdf$1 = $2[0];
      let eff = $2[1];
      let _block;
      let _record = state.proposal_builder;
      _block = new $pb.ProposalBuilder(
        _record.edit_status,
        _record.step,
        _record.project_attachments,
        _record.project_client,
        _record.project_collaborators,
        _record.project_deadline,
        _record.project_name,
        _record.project_owners,
        _record.project_id,
        _record.proposal_pre_filled,
        _record.proposal_name,
        _record.proposal_tags,
        _record.proposal_additional_context,
        _record.proposal_style_guidelines,
        _record.proposal_default_language,
        _record.proposal_languages,
        _record.proposal_qualification_matrix,
        _record.proposal_spreadsheet,
        _record.proposal_document,
        proposal_pdf$1,
        _record.proposal_one_trust,
        _record.proposal_link_id,
        _record.salesforce_id,
      );
      let _pipe = _block;
      let _block$1;
      let $3 = $up_pdf_selector.is_pdf_fetched(msg$1);
      if ($3) {
        _block$1 = $pb.next_step;
      } else {
        _block$1 = $function.identity;
      }
      let _pipe$1 = _block$1(_pipe);
      let _pipe$2 = $pb.insert_default_language(
        _pipe$1,
        new $language.English(),
      );
      let _pipe$3 = ((_capture) => {
        return $state.set_proposal_builder(state, _capture);
      })(_pipe$2);
      return $pair.new$(
        _pipe$3,
        (() => {
          let _pipe$4 = eff;
          let _pipe$5 = $effect.map(
            _pipe$4,
            (var0) => {
              return new $msg.ProposalBuilderHandledPdfSelector(var0);
            },
          );
          return $effect.map(
            _pipe$5,
            (var0) => { return new $msg.ProposalBuilder(var0); },
          );
        })(),
      );
    }
  } else if (msg instanceof $msg.UserConfirmedModalProposalQualificationMatrix) {
    let _pipe = state.proposal_builder;
    let _pipe$1 = $pb.next_step(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_proposal_builder(state, _capture);
    })(_pipe$1);
    let _pipe$3 = $state.set_modal(_pipe$2, new $state.NoModal());
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.UserConfirmedProposalQualificationMatrix) {
    return $pb.require_qualification_matrix(
      state.proposal_builder,
      (qm) => {
        let $ = $proposal.count_qualification_matrix_answers(qm);
        let success = $[0];
        let failure = $[1];
        let total = $[2];
        let is_incomplete = (success + failure) !== total;
        return $bool.lazy_guard(
          is_incomplete,
          () => {
            let _pipe = $state.set_modal(
              state,
              new $state.IncompleteQualificationMatrix(),
            );
            return $pair.new$(_pipe, $effect.none());
          },
          () => {
            let _block;
            let $1 = success > failure;
            if ($1) {
              let _pipe = state.proposal_builder;
              let _pipe$1 = $pb.next_step(_pipe);
              _block = ((_capture) => {
                return $state.set_proposal_builder(state, _capture);
              })(_pipe$1);
            } else {
              _block = $state.set_modal(
                state,
                new $state.DangerousQualificationMatrix(),
              );
            }
            let _pipe = _block;
            return $pair.new$(_pipe, $effect.none());
          },
        );
      },
    );
  } else if (msg instanceof $msg.UserSubmittedProjectDetails) {
    let $ = state.route;
    if ($ instanceof $route.Projects) {
      let $1 = $[0];
      if ($1 instanceof $route.OnGoing) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.Previous) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.ShowProject) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.AddProposal) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.EditProject) {
        let id = $1.project_id;
        return update_project(state, id);
      } else if ($1 instanceof $route.EditProposal) {
        let id = $1.proposal_id;
        return will_update_proposal(state, id);
      } else if ($1 instanceof $route.Proposals) {
        return default_update(state, msg);
      } else {
        return default_update(state, msg);
      }
    } else {
      return default_update(state, msg);
    }
  } else if (msg instanceof $msg.UserSubmittedProposalDetails) {
    let $ = state.route;
    if ($ instanceof $route.Projects) {
      let $1 = $[0];
      if ($1 instanceof $route.OnGoing) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.Previous) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.ShowProject) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.AddProposal) {
        return default_update(state, msg);
      } else if ($1 instanceof $route.EditProject) {
        let id = $1.project_id;
        return update_project(state, id);
      } else if ($1 instanceof $route.EditProposal) {
        let id = $1.proposal_id;
        return will_update_proposal(state, id);
      } else if ($1 instanceof $route.Proposals) {
        return default_update(state, msg);
      } else {
        return default_update(state, msg);
      }
    } else {
      return default_update(state, msg);
    }
  } else if (msg instanceof $msg.UserUsedProposalQualificationMatrix) {
    let _pipe = state.qualification_matrix;
    let _pipe$1 = $list.map(
      _pipe,
      (_capture) => {
        return $pair.new$(_capture, new $qualification_matrix.NotSelected());
      },
    );
    let _pipe$2 = ((_capture) => {
      return $pb.use_qualification_matrix(state.proposal_builder, _capture);
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $state.set_proposal_builder(state, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.UserAddedProjectAttachments) {
    let attachments = msg.attachments;
    return [
      state,
      $effect.from(
        (dispatch) => {
          let _pipe = attachments;
          let _pipe$1 = $list.map(
            _pipe,
            (attachment) => {
              return $promise.map(
                $file.bytes(attachment),
                (body) => {
                  return $result.map(
                    $mime_types.from_string($file.mime(attachment)),
                    (mime) => {
                      return new File($file.name(attachment), body, mime);
                    },
                  );
                },
              );
            },
          );
          let _pipe$2 = $promise.await_list(_pipe$1);
          $promise.map(
            _pipe$2,
            (files) => {
              let _pipe$3 = files;
              let _pipe$4 = $result.all(_pipe$3);
              let _pipe$5 = $result.unwrap(_pipe$4, toList([]));
              let _pipe$6 = new $msg.BrowserExtractedProjectAttachments(_pipe$5);
              let _pipe$7 = new $msg.ProposalBuilder(_pipe$6);
              return dispatch(_pipe$7);
            },
          )
          return undefined;
        },
      ),
    ];
  } else if (msg instanceof $msg.UserWentBack) {
    let router = msg.router;
    return $pair.map_first(
      (() => {
        if (router) {
          return [state.proposal_builder, $modem.back(1)];
        } else {
          return [$pb.back(state.proposal_builder), $effect.none()];
        }
      })(),
      (proposal_builder) => {
        return $state.set_proposal_builder(state, proposal_builder);
      },
    );
  } else if (msg instanceof $msg.UserRemovedProjectAttachment) {
    let index = msg.index;
    let _pipe = state.proposal_builder;
    let _pipe$1 = $pb.remove_project_attachment(_pipe, index);
    let _pipe$2 = ((_capture) => {
      return $state.set_proposal_builder(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.BrowserExtractedProjectAttachments) {
    let attachments = msg.attachments;
    let _pipe = state.proposal_builder;
    let _pipe$1 = $pb.add_project_attachments(_pipe, attachments);
    let _pipe$2 = ((_capture) => {
      return $state.set_proposal_builder(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserPrefilledProposal) {
    let proposal_id = msg.proposal_id;
    let $ = $assoc.get(state.proposals.all, proposal_id);
    if ($ instanceof Ok) {
      let proposal = $[0];
      let _block;
      let _record = state.proposal_builder;
      _block = new $pb.ProposalBuilder(
        _record.edit_status,
        _record.step,
        _record.project_attachments,
        _record.project_client,
        _record.project_collaborators,
        _record.project_deadline,
        _record.project_name,
        _record.project_owners,
        _record.project_id,
        new Some(proposal_id),
        _record.proposal_name,
        proposal.metadata.tags,
        $option.unwrap(proposal.metadata.proposal_context, ""),
        proposal.metadata.style_guidelines,
        _record.proposal_default_language,
        proposal.metadata.languages,
        _record.proposal_qualification_matrix,
        _record.proposal_spreadsheet,
        _record.proposal_document,
        _record.proposal_pdf,
        _record.proposal_one_trust,
        _record.proposal_link_id,
        _record.salesforce_id,
      );
      let _pipe = _block;
      let _pipe$1 = ((_capture) => {
        return $state.set_proposal_builder(state, _capture);
      })(_pipe);
      return $pair.new$(_pipe$1, $effect.none());
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserWillRetriggerProposal) {
    let override_validated = msg.override_validated;
    let $ = state.route;
    if ($ instanceof $route.Projects) {
      let $1 = $[0];
      if ($1 instanceof $route.EditProposal) {
        let id = $1.proposal_id;
        return update_proposal(state, id, true, override_validated);
      } else {
        return [state, $effect.none()];
      }
    } else {
      return [state, $effect.none()];
    }
  } else if (msg instanceof $msg.UserToggledOverrideValidated) {
    let proposal_id = msg.proposal_id;
    let value = msg.value;
    let _pipe = new $state.RetriggerProposalQuestions(proposal_id, value);
    let _pipe$1 = ((modal) => {
      let _record = state;
      return new State(
        _record.window_dimensions,
        _record.access_token,
        _record.analytics,
        _record.client,
        _record.collapsed_navbar,
        _record.comments,
        _record.comments_draft_mentions,
        _record.comments_in_edition,
        _record.connectors,
        _record.content_library,
        _record.copilot,
        _record.custom_rewording_input,
        _record.draft_comments,
        _record.dropdown_unsubscriber,
        _record.feed_opened,
        _record.language,
        _record.loading,
        modal,
        _record.modal_unsubscriber,
        _record.notifications,
        _record.notifications_unread,
        _record.opened_projects,
        _record.organization,
        _record.permissions,
        _record.projects,
        _record.proposal_builder,
        _record.proposals,
        _record.qualification_matrix,
        _record.route,
        _record.running_requests,
        _record.translations,
        _record.user,
        _record.sources_tooltip,
        _record.sources_tooltip_unsubscriber,
        _record.maintenance,
      );
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else {
    return default_update(state, msg);
  }
}
